module.exports = __webpack_public_path__ + "img/19_64.fe92b7e3.png";